{
  "LABEL_MGMT": {
    "HEADER": "标签",
    "HEADER_BTN_TXT": "添加标签",
    "LOADING": "正在获取标签",
    "DESCRIPTION": "标签帮助您对对话和潜在客户进行分类和优先排序。您可以使用侧边栏将标签分配给对话或联系人。",
    "LEARN_MORE": "了解更多关于标签的信息",
    "COUNT": "{n} label | {n} labels",
    "SEARCH_PLACEHOLDER": "搜索标签...",
    "NO_RESULTS": "No labels found matching your search",
    "SEARCH_404": "没有任何项目符合此查询",
    "LIST": {
      "404": "此帐户中没有可用的标签。",
      "TITLE": "管理标签",
      "DESC": "标记可以让您将对话集中起来。",
      "TABLE_HEADER": {
        "NAME": "名称",
        "DESCRIPTION": "描述信息",
        "COLOR": "颜色",
        "ACTION": "操作"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "标签名称",
        "PLACEHOLDER": "标签名称",
        "REQUIRED_ERROR": "标签名称为必填项",
        "MINIMUM_LENGTH_ERROR": "至少需要2个字符",
        "VALID_ERROR": "仅允许使用字母、数字、连字符和下划线"
      },
      "DESCRIPTION": {
        "LABEL": "描述信息",
        "PLACEHOLDER": "标签描述"
      },
      "COLOR": {
        "LABEL": "颜色"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "在侧边栏显示标签"
      },
      "EDIT": "编辑",
      "CREATE": "创建",
      "DELETE": "删除",
      "CANCEL": "取消操作"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "将标签添加到对话",
        "MULTIPLE_SUGGESTION": "选择此标签",
        "DESELECT": "取消选择标签",
        "DISMISS": "忽略建议"
      },
      "POWERED_BY": "Chatwoot AI",
      "DISMISS": "取消",
      "ADD_SELECTED_LABELS": "添加选定的标签",
      "ADD_SELECTED_LABEL": "添加选定的标签",
      "ADD_ALL_LABELS": "添加所有标签",
      "SUGGESTED_LABELS": "建议的标签"
    },
    "ADD": {
      "TITLE": "添加标签",
      "DESC": "标记可以让您将对话集中起来。",
      "API": {
        "SUCCESS_MESSAGE": "标签添加成功",
        "ERROR_MESSAGE": "出现错误，请重试"
      }
    },
    "EDIT": {
      "TITLE": "编辑标签",
      "API": {
        "SUCCESS_MESSAGE": "标签已成功更新",
        "ERROR_MESSAGE": "出错了，请重试"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "删除",
      "API": {
        "SUCCESS_MESSAGE": "标签已成功删除",
        "ERROR_MESSAGE": "出错了，请重试"
      },
      "CONFIRM": {
        "TITLE": "确认删除",
        "MESSAGE": "您确定要删除吗？",
        "YES": "是，删除",
        "NO": "不，保留"
      }
    }
  }
}
